import { render, staticRenderFns } from "./banQuery.vue?vue&type=template&id=0171f650&scoped=true"
import script from "./banQuery.vue?vue&type=script&lang=js"
export * from "./banQuery.vue?vue&type=script&lang=js"
import style0 from "./banQuery.vue?vue&type=style&index=0&id=0171f650&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0171f650",
  null
  
)

export default component.exports